export enum Permission {
  CustomStringsModifyAccess = 'offers_tooling.modify',
  CustomStringsViewAccess = 'offers_tooling.view',
}
